import styled from 'styled-components';

export const InputFile = styled.input.attrs({
  type: 'file',
})`
  display: none;
`;

export const LabelFile = styled.label.attrs({
  htmlFor: 'fileInput',
})`
  cursor: pointer;
  display: block;
  text-align: center;
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
